import { txt } from '../i18n';

// Pliega y despliega un panel del HUD dejando visible su encabezado. Los dos
// paneles (la leyenda y el de la celda) tapan las esquinas del mapa, y a veces
// lo que interesa es el mapa.
export default function BotonColapsar({ colapsado, onToggle }) {
  const etiqueta = colapsado ? txt('comun.expandir') : txt('comun.colapsar');
  return (
    <button
      type="button"
      className="boton-info boton-colapsar"
      onClick={onToggle}
      aria-expanded={!colapsado}
      aria-label={etiqueta}
      title={etiqueta}
    >
      {colapsado ? '+' : '–'}
    </button>
  );
}
